/* ============================================================
   LOH Color Enhancements
   - #2 Selected-color header sync
   - #8 Compare side-by-side (max 3)
   Data shape mirrors hair_color metaobject so app team can
   re-implement in native code reading the same Storefront API.
   ============================================================ */
(function () {
  'use strict';

  const COMPARE_KEY = 'loh:colorCompare';
  const MAX_COMPARE = 3;

  function getColorData() {
    const script = document.querySelector('script[data-variant-colors-rich]');
    if (!script) return [];
    try { return JSON.parse(script.textContent); } catch (_) { return []; }
  }

  function findRecord(records, value) {
    return records.find(r => r.value === value) || null;
  }

  // ---------- #2 Selected color header sync ----------
  function updateSelectedHeader(value) {
    document.querySelectorAll('[data-loh-selected-color]').forEach(el => {
      const records = getColorData();
      const rec = findRecord(records, value);
      const nameEl = el.querySelector('.loh-selected-color__name');
      const thumbEl = el.querySelector('.loh-selected-color__thumb');
      if (nameEl) nameEl.textContent = (rec && rec.label) || value;
      if (thumbEl && rec && rec.swatch_url) {
        thumbEl.style.backgroundImage = `url(${rec.swatch_url})`;
      }
    });
  }

  // ---------- #8 Compare ----------
  function readCompare() {
    try { return JSON.parse(sessionStorage.getItem(COMPARE_KEY) || '[]'); }
    catch (_) { return []; }
  }
  function writeCompare(arr) {
    sessionStorage.setItem(COMPARE_KEY, JSON.stringify(arr));
  }
  function inCompare(value) {
    return readCompare().includes(value);
  }
  function toggleCompare(value) {
    const arr = readCompare();
    const i = arr.indexOf(value);
    if (i >= 0) {
      arr.splice(i, 1);
    } else {
      if (arr.length >= MAX_COMPARE) return false;
      arr.push(value);
    }
    writeCompare(arr);
    syncCompareUI();
    return true;
  }
  function clearCompare() {
    writeCompare([]);
    syncCompareUI();
  }

  function syncCompareUI() {
    const arr = readCompare();
    document.querySelectorAll('.loh-compare-toggle').forEach(btn => {
      const v = btn.dataset.value;
      const active = arr.includes(v);
      btn.classList.toggle('is-active', active);
      btn.textContent = active ? '✓' : '+';
      btn.setAttribute('aria-label', active ? 'Remove from compare' : 'Add to compare');
    });
    const bar = document.querySelector('.loh-compare-bar');
    if (bar) {
      bar.classList.toggle('is-visible', arr.length > 0);
      const countEl = bar.querySelector('.loh-compare-bar__count');
      if (countEl) countEl.textContent = `${arr.length} of ${MAX_COMPARE} selected`;
      const cta = bar.querySelector('.loh-compare-bar__cta');
      if (cta) cta.disabled = arr.length < 2;
    }
  }

  function renderModal() {
    const records = getColorData();
    const arr = readCompare();
    const items = arr.map(v => findRecord(records, v)).filter(Boolean);
    const grid = document.querySelector('.loh-compare-modal__grid');
    if (!grid) return;
    grid.innerHTML = items.map(rec => {
      const modelPhoto = (rec.model_photo_urls && rec.model_photo_urls[0])
        ? `<img class="loh-compare-card__model" src="${rec.model_photo_urls[0]}" alt="${rec.label}">`
        : `<div class="loh-compare-card__model--placeholder">No model photo yet</div>`;
      return `
        <article class="loh-compare-card" data-value="${rec.value.replace(/"/g,'&quot;')}">
          ${modelPhoto}
          <div class="loh-compare-card__body">
            <div class="loh-compare-card__row">
              <span class="loh-compare-card__swatch" style="background-image:url(${rec.swatch_url || ''})"></span>
              <span class="loh-compare-card__name">${rec.label || rec.value}</span>
            </div>
            <button class="loh-compare-card__choose" data-loh-compare-choose>Choose this color</button>
            <button class="loh-compare-card__remove" data-loh-compare-remove>Remove</button>
          </div>
        </article>`;
    }).join('');
  }

  function openModal() {
    renderModal();
    const modal = document.querySelector('.loh-compare-modal');
    if (modal) modal.classList.add('is-open');
  }
  function closeModal() {
    const modal = document.querySelector('.loh-compare-modal');
    if (modal) modal.classList.remove('is-open');
  }

  function applyChoice(value) {
    const input = document.querySelector(`input[name="Color"][value="${value.replace(/"/g,'\\"')}"]`);
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    closeModal();
  }

  // ---------- Init ----------
  function init() {
    // Initial header value
    const checked = document.querySelector('input[name="Color"]:checked');
    if (checked) updateSelectedHeader(checked.value);

    // Header updates on grid change
    document.addEventListener('change', (e) => {
      if (e.target && e.target.name === 'Color') {
        updateSelectedHeader(e.target.value);
      }
    });

    // Compare buttons
    document.addEventListener('click', (e) => {
      const tgl = e.target.closest('.loh-compare-toggle');
      if (tgl) {
        e.preventDefault();
        e.stopPropagation();
        const ok = toggleCompare(tgl.dataset.value);
        if (!ok) {
          tgl.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.2)' }, { transform: 'scale(1)' }], { duration: 200 });
        }
        return;
      }
      if (e.target.closest('.loh-compare-bar__cta')) {
        openModal();
        return;
      }
      if (e.target.closest('.loh-compare-bar__clear')) {
        clearCompare();
        return;
      }
      if (e.target.closest('.loh-compare-modal__close') ||
          (e.target.classList && e.target.classList.contains('loh-compare-modal'))) {
        closeModal();
        return;
      }
      if (e.target.matches('[data-loh-compare-choose]')) {
        const card = e.target.closest('.loh-compare-card');
        if (card) applyChoice(card.dataset.value);
        return;
      }
      if (e.target.matches('[data-loh-compare-remove]')) {
        const card = e.target.closest('.loh-compare-card');
        if (card) {
          toggleCompare(card.dataset.value);
          renderModal();
          if (readCompare().length === 0) closeModal();
        }
        return;
      }
    });

    syncCompareUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
